import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { MultiMediaBasicInfo } from 'src/app/common/models/MultiMediaBasicInfo';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';

@Component({
    selector: 'app-member-editor-main',
    templateUrl: './member-editor-main.component.html',
    styleUrls: ['./member-editor-main.component.scss'],
    standalone: false
})
export class MemberEditorMainComponent implements OnInit {

  public isLeftPanelHide:boolean;
  @Output() edittedImage = new EventEmitter<MultiMediaBasicInfo[]>();
  
  constructor(private parentCommunicatorService: ParentCommunicatorService,
    notifierService: NotifierV2Service) {
    this.parentCommunicatorService.getLeftPanelHideObs.subscribe(IsExpand=> {
      this.isLeftPanelHide = IsExpand;
      console.log("getLeftPanelHideObs in MemberEditorMainComponent : " + this.isLeftPanelHide);
    });

    
   }

  ngOnInit(): void {


  }

}
